import { useEffect, useRef, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import methodModel from "../../methods/methods";
import loader from "../../methods/loader";
import Pagination from "react-js-pagination";
import { useNavigate } from "react-router-dom"
import { IoSearchOutline } from "react-icons/io5";
import { MdModeEdit } from "react-icons/md";

const Cards = ({ filters, setFilters }: any) => {
    const [cards, setCards] = useState([])
    // const [filters, setFilters]: any = useState({ page: 1, count: 9, search: "", audio: "", categoryId: [], subCategoryId: [], start_price: "", end_price: "", status: "active" })
    const [total, setTotal] = useState(0)
    const [categories, setCategories] = useState([])
    const [expandedCategoryIds, setExpandedCategoryIds] = useState<string[]>([]);
    const navigate = useNavigate()
    const isFilterd = useRef(true);

    useEffect(() => {
        let filter: any = sessionStorage.getItem("filter");
        filter = filter ? JSON.parse(filter) : {}
        setFilters((prev: any) => ({ ...prev, ...filter }))
        getCards(filter)
        getCategories()
    }, []);

    useEffect(() => {
        getCards(filters)
    }, [filters?.categoryId, filters?.subCategoryId])

    useEffect(() => {
        if (isFilterd.current) {
            isFilterd.current = false;
            return;
        }
        sessionStorage.setItem("filter", JSON.stringify(filters))
    }, [filters]);

    // To get the Cards and Categories data
    const getCards = (p = {}) => {
        let filter = { ...filters, ...p, status: "active" }
        if (filter?.categoryId?.length > 0) {
            filter = { ...filter, categoryId: String(filter?.categoryId) }
        }
        if (filter?.subCategoryId?.length > 0) {
            filter = { ...filter, subCategoryId: String(filter?.subCategoryId) }
        }
        loader(true)
        ApiClient.get(`card/listing`, filter).then((res: any) => {
            if (res.success) {
                setCards(res?.data)
                setTotal(res?.total)
            }
            loader(false)
        })
    }

    const getCategories = () => {
        ApiClient.get(`category/listing?status=active`).then((res: any) => {
            if (res.success) {
                setCategories(res?.data)
            }
        })
    }

    const toggleCategory = (id: string) => {
        setExpandedCategoryIds(prev =>
            prev.includes(id) ? prev.filter(cid => cid !== id) : [...prev, id]
        );
    };

    // Funcions to handle search bar
    const handleSearch = (e: any) => {
        e.preventDefault()
        getCards({ search: filters?.search })
    }
    const handleSearchInput = (e: any) => {
        if (!e.target.value) {
            getCards({ search: "" })
        }
        setFilters({ ...filters, search: e.target.value })
    }
    const clearSearch = () => {
        setFilters({ ...filters, search: "" })
        getCards({ search: "" })
    }

    // Functions to hanlde filters
    const handlePriceFilter = (value: number, key: string) => {
        if (value < 0) {
            return
        } else {
            setFilters({ ...filters, [key]: value })
        }
    }
    // const hanldeFilters = (id: string, check: boolean, key: string) => {
    //     let idsArray = filters[key]
    //     if (check) {
    //         idsArray.push(id)
    //         setFilters((prev: any) => ({ ...prev, [key]: idsArray }))
    //     } else {
    //         idsArray = idsArray?.filter((item: any) => item != id)
    //         setFilters((prev: any) => ({ ...prev, [key]: idsArray }))
    //     }
    // }
    const hanldeFilters = (id: string, check: boolean, key: string) => {
        let idsArray = filters[key];
        if (check) {
            if (!idsArray.includes(id)) {
                idsArray.push(id);
            }
            if (key === "categoryId") {
                const selectedCategory: any = categories.find((cat: any) => (cat?.id || cat?._id) === id);
                const subIds = selectedCategory?.subcategories?.map((sub: any) => sub?.id || sub?._id) || [];
                setFilters((prev: any) => ({
                    ...prev,
                    [key]: idsArray,
                    subCategoryId: Array.from(new Set([...prev.subCategoryId, ...subIds]))
                }));
            } else {
                setFilters((prev: any) => ({ ...prev, [key]: idsArray }));
            }
        } else {
            idsArray = idsArray.filter((item: any) => item !== id);
            if (key === "categoryId") {
                const deselectedCategory: any = categories.find((cat: any) => (cat?.id || cat?._id) === id);
                const subIds = deselectedCategory?.subcategories?.map((sub: any) => sub?.id || sub?._id) || [];
                setFilters((prev: any) => ({
                    ...prev,
                    [key]: idsArray,
                    subCategoryId: prev?.subCategoryId?.filter((subId: string) => !subIds.includes(subId)),
                }));
            } else {
                setFilters((prev: any) => ({ ...prev, [key]: idsArray }));
            }
        }
    };

    const applyFilters = () => {
        getCards(filters)
    }
    const filterApply = () => {
        if ((filters?.categoryId?.length > 0) || (filters?.subCategoryId?.length > 0) || filters?.start_price || filters?.end_price || filters?.search || filters?.audio) {
            return true
        } else {
            return false
        }
    }
    const clearAllFilters = () => {
        setFilters({ page: 1, count: 9, search: "", audio: "", categoryId: [], subCategoryId: [], start_price: "", end_price: "", status: "active" })
        getCards({ page: 1, count: 9, search: "", audio: "", categoryId: [], subCategoryId: [], start_price: "", end_price: "", status: "active" })
    }

    // Function to handle pagination
    const handlePagination = (e: any) => {
        setFilters({ ...filters, page: e });
        getCards({ page: e });
    };

    return (
        <>
            <div className="grid grid-cols-12 gap-4 lg:gap-8">
                <div className="col-span-12 md:col-span-5 lg:col-span-4 2xl:col-span-3">
                    <div className="text-[20px] font-[600] mb-4">Filter</div>
                    <div className="px-5 py-8 bg-[#F9F9F9] rounded-[20px]">
                        {filterApply() && <div className="border-b-[1px] mb-3 text-right">
                            <span className="text-primary cursor-pointer" onClick={() => clearAllFilters()}>Clear Filters</span>
                        </div>
                        }
                        <div className="border-b-[1px] mb-3">
                            <div className="searchbar flex items-center relative mb-4">
                                <form className="flex w-full" onSubmit={handleSearch}>
                                    <div className="relative w-full">
                                        <input type="text" value={filters?.search} onChange={e => handleSearchInput(e)} className="w-full px-4 h-10 border border-gray-200 placeholder:text-gray-800 pr-10 rounded-lg" placeholder="Search Card..." required />
                                        {filters?.search && (
                                            <i className="fa fa-times absolute right-16 top-1/2 -translate-y-1/2 text-gray-500 text-sm" aria-hidden="true" onClick={(e) => clearSearch()}></i>
                                        )}
                                    </div>
                                    <button type="submit" className="h-full absolute rounded-r-lg right-0 w-12 bg-primary border border-gray-200 cursor-pointer text-white py-2 flex items-center justify-center">
                                        <IoSearchOutline />
                                    </button>
                                </form>
                            </div>
                        </div>
                        {/* <div className="border-b-[1px] mb-3">
                            <h3 className="font-[600] mb-3">Style</h3>
                            <div className="flex items-center mb-4">
                                <input id="default-radio-1" type="radio" checked={filters?.audio === "yes"} onClick={() => setFilters({ ...filters, audio: "yes" })} name="default-radio" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                <label htmlFor="default-radio-1" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">With Sound</label>
                            </div>
                            <div className="flex items-center mb-4">
                                <input id="default-radio-2" type="radio" checked={filters?.audio === "no"} onClick={() => setFilters({ ...filters, audio: "no" })} name="default-radio" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                <label htmlFor="default-radio-2" className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Normal</label>
                            </div>
                        </div> */}
                        <div className="border-b-[1px] mb-3">
                            <h3 className="font-[600] mb-3">Price</h3>
                            <div className="flex justify-between gap-3 mb-4">
                                <form className="flex items-center gap-2 max-w-sm mx-auto">
                                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Min</label>
                                    <input type="number" value={filters?.start_price} onChange={(e: any) => handlePriceFilter(e.target.value, "start_price")} aria-describedby="helper-text-explanation" className="bg-gray-50 border-dashed border-b-[1px] text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="0" required />
                                </form>
                                <div className="border-l-[1px]"></div>
                                <form className="flex items-center gap-2 max-w-sm mx-auto">
                                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Max</label>
                                    <input type="number" value={filters?.end_price} onChange={(e: any) => handlePriceFilter(e.target.value, "end_price")} aria-describedby="helper-text-explanation" className="bg-gray-50 border-dashed border-b-[1px] text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="10000" required />
                                </form>
                            </div>
                        </div>
                        <div className="border-b-[1px] mb-3">
                            <h3 className="font-[600] mb-3">Categories</h3>
                            {categories?.map((item: any, index: number) => {
                                const categoryId = item?.id || item?._id;
                                const isExpanded = expandedCategoryIds.includes(categoryId);

                                return (
                                    <div className="mb-2" key={index}>
                                        <div
                                            onClick={() => toggleCategory(categoryId)}
                                            className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300 flex items-center cursor-pointer"
                                        >
                                            <label className="cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    onChange={(e: any) => hanldeFilters(categoryId, e.target.checked, 'categoryId')}
                                                    checked={filters?.categoryId?.includes(categoryId)}
                                                    className="w-4 h-4 mr-1 text-[000] bg-gray-100 border-gray-300 rounded focus:ring-0 cursor-pointer"
                                                />
                                                {item?.name || "--"}
                                            </label>
                                            {item?.subcategories?.length > 0 &&
                                                <span className="ml-2">{isExpanded ? "▲" : "▼"}</span>
                                            }
                                        </div>

                                        {isExpanded && item?.subcategories?.length > 0 && (
                                            <div className="ml-6 mt-1">
                                                {item.subcategories.map((sub: any, index: number) => {
                                                    return <div key={index} className="flex items-center mb-1">
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => hanldeFilters(sub?._id || sub?.id, e.target.checked, 'subCategoryId')}
                                                            checked={filters?.subCategoryId?.includes(sub?._id || sub?.id)}
                                                            className="w-4 h-4 mr-2 cursor-pointer"
                                                        />
                                                        <span className="text-sm text-gray-800 dark:text-gray-200">{sub?.name}</span>
                                                    </div>
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                        <div className="mb-3">
                            <button type="button" onClick={() => applyFilters()} className="bg-[#F58D18] w-full rounded-md h-[50px] text-white flex justify-center items-center">Apply</button>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 md:col-span-7 lg:col-span-8 2xl:col-span-9">
                    <div className="flex gap-5 justify-between mb-4">
                        <p className="text-primary text-3xl font-[600]" id="premiumGreeting">Premium Greetings</p>
                    </div>
                    {cards?.length != 0 ?
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:col-sapn-4 gap-4">
                            {cards && cards?.map((item: any, index: number) => {
                                return (
                                    <div
                                        className="bg-white p-2 rounded-xl cursor-pointer group"
                                        key={index}
                                        onClick={(e) => {
                                            navigate(`/card/detail/${item?.id || item?._id}`);
                                        }}
                                    >
                                        <div className="overflow-hidden rounded-xl">
                                            <img
                                                src={methodModel.noImg(item?.image)}
                                                className="h-[240px] xl:h-[240px] 2xl:h-[300px] w-full object-cover rounded-xl transition-transform duration-300 group-hover:scale-110"
                                                alt={item?.name || "Card Image"}
                                            />
                                        </div>
                                        <div className="mt-2 p-3">
                                            <h3 className="font-[600] text-[18px] mb-3 capitalize">
                                                {item?.name}
                                            </h3>
                                            <div className="flex gap-4 justify-between items-end">
                                                <div className="w-100">
                                                    <div className="flex gap-2 flex-wrap items-center mb-3">
                                                        <div className="text-[#667479] text-[12px] leading-[14px]">
                                                            Sound{" "}
                                                            <span className="font-[600]">
                                                                {item?.audiosDetail?.length > 0 ? "yes" : "no"}
                                                            </span>
                                                        </div>
                                                        ·
                                                        <div className="text-[#667479] text-[12px] leading-[14px]">
                                                            Category:{" "}
                                                            <span className="font-[600]">
                                                                {item?.categoryDetail?.name || "--"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="text-[15px]">${item?.price} </div>
                                                </div>
                                                <div>
                                                    <span className="bg-[#F58D18] lg:w-[40px] lg:h-[40px] 2xl:w-[50px] 2xl:h-[50px] rounded-[20px] text-white flex justify-center items-center cursor-pointer transition-transform duration-300 hover:scale-110">
                                                        <MdModeEdit className="text-xl 2xl:text-2xl" />
                                                    </span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                )
                            })}
                        </div>
                        :
                        <div className="mt-12 text-center">No Cards Found</div>
                    }
                    {cards?.length != 0 &&
                        <div className="mt-10 flex items-end justify-end">
                            <Pagination
                                activePage={filters?.page}
                                itemsCountPerPage={filters?.count}
                                totalItemsCount={total}
                                pageRangeDisplayed={1}
                                onChange={handlePagination}
                                hideFirstLastPages={true}
                            />
                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default Cards